import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=c38bca2a&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=c38bca2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38bca2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c38bca2a')) {
      api.createRecord('c38bca2a', component.options)
    } else {
      api.reload('c38bca2a', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=c38bca2a&scoped=true&", function () {
      api.rerender('c38bca2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21QE22aZ8kDkx/JS/comp/Voucher.vue"
export default component.exports